import React from 'react';
import {Helmet} from 'react-helmet';
// import ReactMarkdown from 'react-markdown';
import intl from 'react-intl-universal';

// import help from './help.md';

const Help = () => (
  <div className='container'>
    <Helmet>
      <title>{intl.get('Help | ImageResize.org')}</title>
    </Helmet>
    {/* <ReactMarkdown className='section' source={help} /> */}
    <div className="section">
      <h1>{intl.get('HelpPage.PageHeader')}</h1>
      <ul>
        <li>
          <p><strong>{intl.get('HelpPage.SingleImagePara1')}</strong></p>
          <p>{intl.get('HelpPage.SingleImagePara2')}</p>
        </li>
        <li>
          <p><strong>{intl.get('HelpPage.MultipleImagePara1')}</strong></p>
          <p>{intl.get('HelpPage.MultipleImagePara2')}</p>
        </li>
      </ul>
    </div>
  </div>
);

export default Help;



// WEBPACK FOOTER //
// ./src/containers/Help/index.jsx